import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import { theme } from 'styles/theme/theme';

export const Logo = styled(Link)`
  color: ${theme.colors.InkOnDark};

  & span {
    color: ${({ theme }) => theme.colors.DarkYellow};
  }
`;
